import { GetById, GetByIds, GetByPostalCode, } from '@price-pages-agency-cards/src/application/agency.use-cases';
export const fetchByIds = async (agencyGateway, ids, brand) => {
    const useCase = new GetByIds(agencyGateway);
    return await useCase.execute(ids, brand);
};
export const fetchByPostalCode = async (agencyGateway, postalCode, brand) => {
    const useCase = new GetByPostalCode(agencyGateway);
    return await useCase.execute(postalCode, brand);
};
export const fetchById = async (agencyGateway, agencyId, brand, locale) => {
    const useCase = new GetById(agencyGateway);
    return await useCase.execute(agencyId, brand, locale);
};
